import { useGetIdentity, useGetList, usePermissions } from 'react-admin';
import { Typography } from '@mui/material';

export const TasksListEmpty = () => {
    const { identity } = useGetIdentity();
    const { permissions } = usePermissions();

    const { total } = useGetList(
        'tasks',
        {
            pagination: { page: 1, perPage: 1 },
            filter: {
                id_vendedor: permissions !== 'admin' ? identity?.id : null,
            },
        },
        { enabled: !!identity }
    );

    if (total) return null;

    return (
        <Typography variant="body2">
            Tarefas adicionadas aos seus contatos e fornecedores vão aparecer aqui.
        </Typography>
    );
};
